var map = {
	"./20250916.png": 9515,
	"./20250928.png": 8592,
	"./20251006.png": 7406,
	"./20251027.png": 3917,
	"./20251103.png": 4930,
	"./20251110.png": 3550,
	"./20251117.png": 1265,
	"./20251124.png": 9931,
	"./20251201.png": 2499,
	"./20251212.png": 6599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1084;